<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="$router.push('/menu')">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h1 class="page-title">ユーザー一括作成</h1>
        <div class="section">
          <a @click.prevent="downloadCSVTemplate" href="#" class="csv-link">CSVテンプレートをダウンロード</a>
        </div>
        <div class="section upload-section">
          <input type="file" @change="handleFileChange" />
          <button :disabled="isSubmitting" @click="uploadCSV" class="btn-primary">CSVアップロード</button>
        </div>
        <div v-if="message" class="message-box" :class="isSuccess ? 'message-success' : 'message-error'">
          {{ message }}
        </div>
        <div class="section">
          <h2 class="section-title">所属チームID一覧</h2>
          <p class="section-note">CSVの所属欄には以下のIDを指定してください。</p>
          <table class="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>名称</th>
                <th>表記名</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="team in teams" :key="team.id">
                <td>{{ team.id }}</td>
                <td>{{ team.name }}</td>
                <td>{{ team.display_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedFile: null,
      isSubmitting: false,
      isSuccess: false,
      message: "", // メッセージを格納するデータプロパティを追加
      teams: []
    };
  },
  mounted() {
    this.fetchTeams();
  },
  methods: {
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },
    async fetchTeams() {
      try {
        axios.get('/teams').then(response => {
          this.teams = response.data; // メッセージをセット
        });
      } catch (error) {
        console.error(error);
      }
    },
    async downloadCSVTemplate() {
        axios.get('/users_csv_template', {responseType: 'blob',}).then(response => {
          try {
            // Blobからファイルを作成
            const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
            // ダウンロード用のリンクを作成し、クリックしてダウンロード
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'users_template.csv';
            link.click();
          } catch (error) {
            console.error(error);
          }
        });
    },
    async uploadCSV() {
      if (this.isSubmitting) {
        // 既にサブミット中の場合は何もしない
        return;
      }

      if (this.selectedFile == null) {
        this.message = "ファイルを指定してください。";
        return;
      }
      this.isSubmitting = true;
      this.message = "";
      this.isSuccess = false;

      const formData = new FormData();
      formData.append('file', this.selectedFile);

      try {
        axios.post('/users_csv_upload', formData).then(response => {
          console.log(response.data.result);
          if (response.data.result) {
            this.isSuccess = true;
          }
          this.message = response.data.message; // メッセージをセット
        }).catch((error) => {
          alert(error.response.data.detail);
        });
      } catch (error) {
        console.log(error);
        this.message = "エラーが発生しました。"; // エラーメッセージをセット
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.section { margin-bottom: 28px; }

.section-title {
  font-size: 1rem; font-weight: 700; color: #1E293B;
  margin: 0 0 8px 0;
}

.section-note {
  font-size: 0.85rem; color: #64748B; margin: 0 0 14px 0;
}

.csv-link {
  font-size: 0.9rem; color: #3B82F6; font-weight: 600;
  text-decoration: none; cursor: pointer;
}
.csv-link:hover { text-decoration: underline; }

.upload-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.message-box {
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 20px;
}
.message-success { background: #DBEAFE; color: #1D4ED8; border: 1px solid #93C5FD; }
.message-error   { background: #FEE2E2; color: #B91C1C; border: 1px solid #FCA5A5; }

.data-table { width: 100%; border-collapse: collapse; }
.data-table th {
  text-align: left; padding: 12px 16px;
  background: #F8FAFC; color: #475569;
  font-size: 0.8rem; font-weight: 700;
  border-bottom: 2px solid #E2E8F0;
}
.data-table td {
  padding: 14px 16px; border-bottom: 1px solid #F1F5F9;
  font-size: 0.9rem; color: #334155;
}
.data-table tr:hover td { background: #F8FAFC; }

.btn-primary {
  padding: 10px 24px; border-radius: 8px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-primary:hover { background: #2563EB; }
.btn-primary:disabled { background: #93C5FD; cursor: not-allowed; }
</style>
